import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
export var Table = function (_a) {
    var headers = _a.headers, rows = _a.rows, selfRow = _a.selfRow, tableContainerClassName = _a.tableContainerClassName, _b = _a.rowClassName, rowClassName = _b === void 0 ? IdStyles.TableRowRankingBig : _b;
    var tableHeader = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tr" }),
        React.createElement("div", { className: "tr th " + rowClassName }, headers),
        React.createElement("div", { className: "tr__divider" })));
    return (React.createElement("div", { className: "flex flex--stacked h100" },
        React.createElement("div", { className: (tableContainerClassName ? tableContainerClassName : "") + " w100" },
            tableHeader,
            React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" }, rows)),
        selfRow));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/table/Table.tsx
// module id = 363
// module chunks = 3